module.exports = __webpack_public_path__ + "static/media/sport-et-citoyennete_2.7285d9a7.jpg";